module.exports = __webpack_public_path__ + "static/media/WALKER AUDIO ONLY UPRGADE AVAILABLE.fc4e0324.png";